import { render, staticRenderFns } from "./AdminPanelYoutvPackageSellingHistoryEdit.vue?vue&type=template&id=8486163a&"
import script from "./AdminPanelYoutvPackageSellingHistoryEdit.vue?vue&type=script&lang=js&"
export * from "./AdminPanelYoutvPackageSellingHistoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports